(function() {
  function fixLayout() {
    // === 1. 修复 quantity-input 高度和宽度 ===
    var qtyInput = document.querySelector('quantity-input');
    if (qtyInput) {
      qtyInput.style.width = '100%';
      var wrapper = document.createElement('div');
      wrapper.style.height = '44px';
      wrapper.style.width = '100%';
      wrapper.style.marginBottom = '10px';
      wrapper.style.overflow = 'hidden';
      qtyInput.parentNode.insertBefore(wrapper, qtyInput);
      wrapper.appendChild(qtyInput);
    }

    // === 2. 隐藏空的 DIBS 容器 ===
    var widget = document.querySelector('.lb-ordereasy-product-widget');
    if (widget) {
      var count = 0;
      var timer = setInterval(function() {
        count++;
        var btn = widget.querySelector('.btn--primary');
        if (!btn || !btn.textContent.trim()) {
          widget.style.display = 'none';
          widget.style.height = '0';
          widget.style.marginTop = '0';
          widget.style.marginBottom = '0';
          clearInterval(timer);
          return;
        }
        if (count > 20) clearInterval(timer);
      }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixLayout);
  } else {
    fixLayout();
  }
})();